module.exports = "<div class=\"root\">\n        <wallpaper class=\"scope\"></wallpaper>\n        <files class=\"scope\" :files.sync=\"files\"></files>\n        <selection class=\"scope\"></selection>\n        <application class=\"scope\" :apps.sync=\"apps\"></application>\n        <taskbar class=\"scope\" :apps.sync=\"apps\"></taskbar>\n        <mousemenu class=\"scope\"></mousemenu>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/root.vue
 ** module id = 106
 ** module chunks = 0
 **/